import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useConsent, setConsent } from "@/lib/consent";

export const CookieBanner = () => {
  const consent = useConsent();

  return (
    <AnimatePresence>
      {!consent && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          role="dialog"
          aria-label="Informativa cookie"
          className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
          data-testid="cookie-banner"
        >
          <div className="mx-auto flex max-w-5xl flex-col gap-5 border border-gold/30 bg-navy/95 p-6 text-slate-200 shadow-2xl shadow-black/40 backdrop-blur-md sm:flex-row sm:items-center sm:gap-8 sm:p-7">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-gold/40 bg-gold/10 text-gold">
              <Cookie className="h-5 w-5" />
            </span>
            <div className="flex-1">
              <p className="font-serif text-lg text-white">Utilizziamo i cookie</p>
              <p className="mt-1 text-sm leading-relaxed text-slate-300">
                Questo sito utilizza solo cookie tecnici e, previo tuo consenso, cookie di terze parti di Google Maps per mostrare le mappe delle nostre sedi.
                Se rifiuti, le mappe non verranno caricate. Puoi cambiare scelta in qualsiasi momento dal footer.{" "}
                <Link to="/cookie-policy" className="underline decoration-gold/60 underline-offset-4 hover:text-gold" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
              <button
                onClick={() => setConsent("rejected")}
                data-testid="cookie-reject-button"
                className="border border-white/25 px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-white transition-colors hover:border-gold hover:text-gold"
              >
                Solo tecnici
              </button>
              <button
                onClick={() => setConsent("accepted")}
                data-testid="cookie-accept-button"
                className="bg-gold px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-navy transition-colors hover:bg-gold-light"
              >
                Accetta tutti
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
